"use strict";

var _regeneratorRuntime = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _asyncToGenerator = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var functions_1 = require("firebase/functions");

var firebase_1 = require("../../config/firebase");

var Produit_1 = __importDefault(require("../Espace/Produit"));

var Delivery = /*#__PURE__*/function () {
  function Delivery() {
    _classCallCheck(this, Delivery);
  }

  _createClass(Delivery, null, [{
    key: "getInfo",
    value: function getInfo(quantity, produit) {
      var isALot = produit.isALot,
          isStackable = produit.isStackable,
          qtyInLot = produit.qtyInLot,
          shipping2Carriers = produit.shipping2Carriers,
          shippingRisky = produit.shippingRisky,
          shippingSharing = produit.shippingSharing,
          shippingSupport = produit.shippingSupport,
          stackableByQty = produit.stackableByQty;
      var sharing = Number(shippingSharing || 0);
      var support = Number(shippingSupport || 0);
      var totalVolume = 0;
      var totalWeight = 0;
      var newQty;
      newQty = quantity;

      if (isALot) {
        if (!qtyInLot) {
          throw new Error("Impossible d'estimer le co\xFBt livraison car la quantit\xE9 du lot n'est pas renseign\xE9e");
        }

        newQty = quantity * qtyInLot;
      }

      var nbVolume = 0;
      var nbWeight = 0;
      var dimensionMax = Produit_1.default.calcDimensionMax(produit);
      var isHeavy = produit.isHeavy || false;
      var weight = Produit_1.default.calcWeight(produit);

      if (weight) {
        totalWeight += newQty * weight;

        if (totalWeight > 30) {
          if (weight > 30) {
            isHeavy = true;
            nbWeight = newQty;
          } else if (Math.floor(1 / (weight / 30)) > 1) {
            nbWeight = Math.min(newQty, Math.max(1, newQty / Math.floor(1 / (weight / 30))));
          } else {
            nbWeight = newQty;
          }
        } else if (dimensionMax > 0 && Math.floor(1 / (dimensionMax / 300)) > 1) {
          nbWeight = Math.min(newQty, Math.max(1, newQty / Math.floor(1 / (dimensionMax / 300))));
        } else {
          nbWeight = newQty;
        }
      }

      var volume = Produit_1.default.calcVolume(produit);

      if (volume) {
        var adjustment = 0.2;

        if (isStackable) {
          if (!stackableByQty || newQty <= stackableByQty) {
            nbVolume = 1;
            totalVolume += volume + (newQty - 1) * volume * Number(adjustment);
          } else {
            var nbQtyByLot = Math.floor(newQty / stackableByQty);
            nbVolume = nbQtyByLot;

            for (var i = 0; i < nbQtyByLot; i += 1) {
              totalVolume += volume + (stackableByQty - 1) * volume * Number(adjustment);
            }

            if (nbQtyByLot * stackableByQty < newQty) {
              nbVolume += 1;
              var reliquat = newQty - nbQtyByLot * stackableByQty;
              totalVolume += volume + (reliquat - 1) * volume * Number(adjustment);
            }
          }
        } else {
          nbVolume = newQty;
          totalVolume += newQty * volume;
        }
      }

      return {
        dimensionMax: dimensionMax,
        isHeavy: isHeavy,
        nbVolume: nbVolume,
        nbWeight: nbWeight,
        sharing: sharing,
        support: support,
        totalVolume: totalVolume,
        volume: volume,
        express: !shipping2Carriers && !isHeavy && !shippingRisky && dimensionMax < 300 && (0 === nbVolume || totalVolume * 200 / nbVolume < 30) && (0 === nbWeight || totalWeight / nbWeight < 30),
        isOutsize: dimensionMax >= 300,
        totalVW: Math.ceil(totalVolume * 200 * 2) / 2,
        totalWeight: Math.ceil(totalWeight * 2) / 2,
        volumetricWeight: Math.ceil(volume * 200 * 2) / 2,
        weight: Math.ceil(weight * 2) / 2
      };
    }
  }, {
    key: "calculate",
    value: function () {
      var _calculate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var produits, express, cumul, produitData, produitDocs, espaceId, contactAddress, contactCity, contactCountry, contactZip, transport, result, _result$data$errors$m, _result$data$errors$m2, message;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                produits = data.produits;

                if (!(!produits || 0 === produits.length)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", {
                  cost: 0,
                  error: "Il n'y a pas de produits  à livrer"
                });

              case 3:
                express = 0;
                cumul = {
                  dimensionMax: 0,
                  express: false,
                  isHeavy: false,
                  isOutsize: false,
                  nbVolume: 0,
                  nbWeight: 0,
                  sharing: 0,
                  support: 0,
                  totalVolume: 0,
                  totalVW: 0,
                  totalWeight: 0,
                  volume: 0,
                  volumetricWeight: 0,
                  weight: 0
                };
                produitData = new Produit_1.default({
                  espaceId: data.boutique
                });
                _context.next = 8;
                return Promise.all(produits.map(function (p) {
                  return produitData.findById(p.id).then(function (documentSnapshot) {
                    return {
                      price: p.price,
                      produit: documentSnapshot,
                      quantity: p.quantity
                    };
                  });
                }));

              case 8:
                produitDocs = _context.sent;
                produitDocs.forEach(function (_ref) {
                  var produit = _ref.produit,
                      quantity = _ref.quantity;
                  var result = Delivery.getInfo(quantity, produit);
                  express += result.express ? 1 : 0;
                  cumul.dimensionMax += result.dimensionMax;
                  cumul.isHeavy = cumul.isHeavy || result.isHeavy;
                  cumul.nbVolume += result.nbVolume;
                  cumul.nbWeight += result.nbWeight;
                  cumul.sharing += result.sharing;
                  cumul.support += result.support;
                  cumul.totalVolume += result.totalVolume;
                  cumul.totalVW += result.totalVW;
                  cumul.totalWeight += result.totalWeight;
                  cumul.volume += result.volume;
                  cumul.volumetricWeight += result.volumetricWeight;
                  cumul.weight += result.weight;
                });

                if (express > 0) {
                  cumul.express = true;
                }

                if (!(cumul.totalWeight > 0 || cumul.totalVolume > 0)) {
                  _context.next = 21;
                  break;
                }

                espaceId = data.boutique, contactAddress = data.contactAddress, contactCity = data.contactCity, contactCountry = data.contactCountry, contactZip = data.contactZip;
                transport = (0, functions_1.httpsCallable)(firebase_1.functions, 'transport');
                _context.next = 16;
                return transport({
                  espaceId: espaceId,
                  action: 'estimation',
                  country: contactCountry,
                  extra: false,
                  q: "".concat(contactAddress, " ").concat(contactZip, " ").concat(contactCity, " ").concat(contactCountry),
                  shippingInfo: cumul
                });

              case 16:
                result = _context.sent;

                if (!(result === null || result === void 0 ? void 0 : result.data.errors)) {
                  _context.next = 20;
                  break;
                }

                _result$data$errors$m = result.data.errors.map(function (e) {
                  return e.message;
                }), _result$data$errors$m2 = _slicedToArray(_result$data$errors$m, 1), message = _result$data$errors$m2[0];
                throw new Error(message);

              case 20:
                return _context.abrupt("return", result.data);

              case 21:
                throw new Error('Impossible de calculer le coût de la livraison');

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function calculate(_x) {
        return _calculate.apply(this, arguments);
      }

      return calculate;
    }()
  }, {
    key: "estimate",
    value: function () {
      var _estimate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(espaceId, produits, country, q) {
        var express, cumul, produitData, produitDocs, transport, result, _result$data$errors$m3, _result$data$errors$m4, message;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!produits || 0 === produits.length)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {
                  cost: 0,
                  error: "Il n'y a pas de produits  à livrer"
                });

              case 2:
                express = 0;
                cumul = {
                  dimensionMax: 0,
                  express: false,
                  isHeavy: false,
                  isOutsize: false,
                  nbVolume: 0,
                  nbWeight: 0,
                  sharing: 0,
                  support: 0,
                  totalVolume: 0,
                  totalVW: 0,
                  totalWeight: 0,
                  volume: 0,
                  volumetricWeight: 0,
                  weight: 0
                };
                produitData = new Produit_1.default({
                  espaceId: espaceId
                });
                _context2.next = 7;
                return Promise.all(produits.map(function (p) {
                  return produitData.findById(p.id).then(function (documentSnapshot) {
                    return {
                      price: p.price,
                      produit: documentSnapshot,
                      quantity: p.quantity
                    };
                  });
                }));

              case 7:
                produitDocs = _context2.sent;
                produitDocs.forEach(function (_ref2) {
                  var produit = _ref2.produit,
                      quantity = _ref2.quantity;
                  var result = Delivery.getInfo(quantity, produit);
                  express += result.express ? 1 : 0;
                  cumul.dimensionMax += result.dimensionMax;
                  cumul.isHeavy = cumul.isHeavy || result.isHeavy;
                  cumul.nbVolume += result.nbVolume;
                  cumul.nbWeight += result.nbWeight;
                  cumul.sharing += result.sharing;
                  cumul.support += result.support;
                  cumul.totalVolume += result.totalVolume;
                  cumul.totalVW += result.totalVW;
                  cumul.totalWeight += result.totalWeight;
                  cumul.volume += result.volume;
                  cumul.volumetricWeight += result.volumetricWeight;
                  cumul.weight += result.weight;
                });

                if (express > 0) {
                  cumul.express = true;
                }

                if (!(cumul.totalWeight > 0 || cumul.totalVolume > 0)) {
                  _context2.next = 19;
                  break;
                }

                transport = (0, functions_1.httpsCallable)(firebase_1.functions, 'transport');
                _context2.next = 14;
                return transport({
                  country: country,
                  espaceId: espaceId,
                  q: q,
                  action: 'estimation',
                  extra: false,
                  shippingInfo: cumul
                });

              case 14:
                result = _context2.sent;

                if (!(result === null || result === void 0 ? void 0 : result.data.errors)) {
                  _context2.next = 18;
                  break;
                }

                _result$data$errors$m3 = result.data.errors.map(function (e) {
                  return e.message;
                }), _result$data$errors$m4 = _slicedToArray(_result$data$errors$m3, 1), message = _result$data$errors$m4[0];
                throw new Error(message);

              case 18:
                return _context2.abrupt("return", result.data);

              case 19:
                throw new Error('Impossible de calculer le coût de la livraison');

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function estimate(_x2, _x3, _x4, _x5) {
        return _estimate.apply(this, arguments);
      }

      return estimate;
    }()
  }, {
    key: "calculateWithShippingValue",
    value: function calculateWithShippingValue(value, shippingInfo) {
      var nbWeight = shippingInfo.nbWeight,
          nbVolume = shippingInfo.nbVolume,
          support = shippingInfo.support,
          sharing = shippingInfo.sharing,
          totalVolume = shippingInfo.totalVolume,
          totalWeight = shippingInfo.totalWeight;
      var express = value.express,
          pec = value.pec,
          coefVolume = value.coefVolume,
          coefWeight = value.coefWeight;
      var price;
      var volume = totalVolume || 0;
      var weight = totalWeight || 0;

      if (express) {
        price = Math.round((nbWeight || nbVolume) * Number(pec || 0) + (support || 0) - (sharing || 0));
      } else {
        price = Math.round(volume * Number(coefVolume || 0) + weight * Number(coefWeight || 0) + Number(pec || 0) + (support || 0) - (sharing || 0));
      }

      return Math.ceil(price / 5) * 5;
    }
  }]);

  return Delivery;
}();

exports.default = Delivery;